import {app} from "@/app";
const BaseMethodsFunctions = require('./BaseMethodsFunctions')

app.mixin(BaseMethodsFunctions.default)